/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import {
    ItemFamilySelect, WashingSelect,
    SizeSelect, ColorSelect, BrandSelect,
    CategoriesSelect, CutSelect, SupplierSelect,
    TagsSelect, AttributeSelect,
    DetailsSelect
} from "components/ProductComponents";
import Reports from "./Reports";
import { ModalArchive } from "shared/components/product/archiving";
import { AppContext } from "components";
import { ItemStatusTag } from "shared/components/customers/boxes/common/item-figure/item-status-tag";
// models
import Product from "models/product";

// toast
import "react-toastify/dist/ReactToastify.css";

// base container
import ProductBaseContainer from "./ProductBaseContainer";
import ProductLogsContainer from "./ProductLogsContainer";

import { getTheProduct, getTheProductLogs, recreateCurrentProduct, saveProductChanges, verifyBarcode } from "./helper";
import { CustomerSearchInput } from "shared/components/customers/misc/customer-search-input";

// pipes
import { titleCasePipe } from "shared/pipes";
import CurrencySelect from "components/ProductComponents/CurrencySelect";
import GenderSelect from "components/ProductComponents/GenderSelect";
import PlatformSoldSelect from "components/ProductComponents/PlatformSoldSelect";
import MaterialComposition from "components/ProductComponents/MaterialComponent";
// import { DatePickerYear } from "shared/components/bulma/date-picker/DatePickerYear";
import { Checkbox } from "shared/components/bulma/checkbox";
import TypeofgarmentSelect from "components/ProductComponents/TypeofgarmentSelect";
import MintConditionSelect from "components/ProductComponents/MintConditionSelect";
import WashingDetergentButton from "components/ProductComponents/WashingDetergentButton";
import ImageModal from "./ImageModal";
import ImageCom from "./ImageCom";

const role = localStorage.getItem('role');
const DEFAULT_TABS = ['Logs', 'Info', 'Repairs'];

class ProductEditContainer extends ProductBaseContainer {

    constructor(props) {
        super(props);

        this.state = {
            startIndex:0,
            ...this.state,
            isModalVisible: false,
            isArchiveModalVisible: false,
            ...{ pristineProduct: new Product() },
            activeTab: DEFAULT_TABS[0],
        };


        this.onChange = this.onChange.bind(this);
        this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
        this.setState = this.setState.bind(this);
        this.getProduct = this.getProduct.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.editProduct = this.editProduct.bind(this);
        this.recreateProduct = this.recreateProduct.bind(this);
        this.onLogsRetrieved = this.onLogsRetrieved.bind(this);
        this.setActiveTab = this.setActiveTab.bind(this);
        this.handleModal = this.handleModal.bind(this);
        this.handleArchiveModal = this.handleArchiveModal.bind(this);
        this.archiveButton = this.archiveButton.bind(this);
    }

    onChange(event) {
        const { product } = this.state;
        const { name, value } = event.target;
        product[name] = value;

        if (['size', 'category'].includes(name)) {
            product.location = this.generateLocationCode();
        }

        this.setState({ product });
    }
    onChangeCheckbox(event) {
        const { product } = this.state;
        const { name } = event.currentTarget;
        product[name] = !product.sold;
        this.setState({ product });
        
    }
    componentDidMount() {
        // getting product data
        this.getProduct();
        this.useToast();

        // set active tab
        const search = this.props.location.search;
        const tab = new URLSearchParams(search).get('tab');

        if (tab) {
            const activeTab = DEFAULT_TABS.find((t) => t.toLowerCase() === tab.toLowerCase());
            this.setState({ activeTab });
        }
    }

    onLogsRetrieved(product) {
        this.setState({ product })
    }

    async getProduct() {
        this.context.showLoading();

        const productId = this.props.match.params.id;
        let result = null;
        try {
            result = await getTheProduct(productId, this.country);
        } catch (error) {
            this.showErrorToast(error.message);
            // this.props.history.push('/products');
            return;
        }

        const product = new Product(result);
        const pristineProduct = new Product(result);

        product.logs = await getTheProductLogs(product);
        this.setState({ product, pristineProduct });
        this.context.hideLoading();
    };

    archiveButton() {
        const { status } = this.state.product
        if (["to_be_archived", "archived"].includes(status)) {
            return (
                <p>{titleCasePipe.transform(status)}</p>
            );
        }
        return (
            <button className="button is-link" onClick={this.handleArchiveModal} >Archive</button>
        )
    }

    async saveChanges() {
        const { product, pristineProduct,afterwashImagesURL,beforewashImagesURL } = this.state;

        await this.context.showLoading();

        // if (file && file.length > 0) {
        //     file.url = await this.handleUpload(file[0], product.barcode);
        //     product.imageURLs[0] = file.url;
        // }
        if (beforewashImagesURL.frontUrl && beforewashImagesURL.frontUrl.length > 0) {
            beforewashImagesURL.frontUrl.url = await this.handleUpload(beforewashImagesURL.frontUrl[0], product.barcode);
            product["beforewashImagesURL"]["frontUrl"][0] = beforewashImagesURL.frontUrl.url;
        }
        if (beforewashImagesURL.backUrl && beforewashImagesURL.backUrl.length > 0) {
            beforewashImagesURL.backUrl.url = await this.handleUpload(beforewashImagesURL.backUrl[0], product.barcode);
            product["beforewashImagesURL"]["backUrl"][0] = beforewashImagesURL.backUrl.url;
        }
        if (afterwashImagesURL.frontUrl && afterwashImagesURL.frontUrl.length > 0) {
            afterwashImagesURL.frontUrl.url = await this.handleUpload(afterwashImagesURL.frontUrl[0], product.barcode);
            product["afterwashImagesURL"]["frontUrl"][0] = afterwashImagesURL.frontUrl.url;
        }
        if (afterwashImagesURL.backUrl && afterwashImagesURL.backUrl.length > 0) {
            afterwashImagesURL.backUrl.url = await this.handleUpload(afterwashImagesURL.backUrl[0], product.barcode);
            product["afterwashImagesURL"]["backUrl"][0] = afterwashImagesURL.backUrl.url;
        }
        // checks if barcode changes
        if (product.barcode !== pristineProduct.barcode) {
            try {
                await verifyBarcode(product.barcode);
            } catch (error) {
                this.showErrorToast(error.message);
                this.context.hideLoading();

                return;
            }

            const res = this.recreateProduct(product);
            res ? this.showSuccessToast("Changes successfully saved!") :
                this.showErrorToast(`Changes not saved. Please try again.`);
            this.context.hideLoading();

            return;
        }
        this.editProduct(product);

        this.context.hideLoading();
    }

    async editProduct(product) {
        const { pristineProduct } = this.state;

        const res = await saveProductChanges(product, pristineProduct);
        if (res) {
            this.showSuccessToast("Changes successfully saved!");
        } else {
            this.showErrorToast(`Changes not saved. Please try again.`);
        }
    }

    async recreateProduct(product) {
        const { pristineProduct } = this.state;

        try {
            await recreateCurrentProduct(product, pristineProduct);
            window.history.replaceState({}, document.title, `/products/${product.barcode}`);
        } catch (error) {
            this.showErrorToast(`Changes not saved. Please try again.`);
        }

        this.context.hideLoading();
    }

    setActiveTab(tab) {
        this.setState({ activeTab: tab });
        const pathname = this.props.history.location.pathname;
        this.props.history.push({
            pathname,
            search: `?tab=${tab.toLowerCase()}`
        })
    }

    renderInfo(product) {
        if (product.model_ref) {
            return (
                <>
                    <div className="columns">
                        <div className="column">
                            <div className="field">
                                <label className="label">Barcode</label>
                                <div className="control">
                                    <input
                                        className="input"
                                        name="barcode"
                                        id="barcode"
                                        type="text"
                                        value={product.barcode}
                                        onChange={this.onChange}
                                        placeholder="XXXXXXXX"
                                        disabled={!["admin", "buyer"].includes(role)} />
                                </div>
                            </div>
                            <SizeSelect name="size" label="Size" value={product.size} onChange={this.onChange} />
                        </div>
                        <div className="column">

                            <fieldset disabled className="is-borderless">
                                <SupplierSelect name="supplier" label="Supplier" value={product.supplier} onChange={this.onChange} />

                                <BrandSelect name="brand" label="Brand" value={product.brand} onChange={this.onChange} disabled />

                                <CategoriesSelect name="category" value={product.category} label="Categories" onChange={this.onChange} disabled />
                            </fieldset>

                        </div>
                    </div>
                    <div className="columns">
                        <div className="column is-8"></div>
                        <div className="column">
                            <button type="button" className="button is-primary is-pulled-right" onClick={this.saveChanges}>Save Changes for this product</button>
                        </div>
                        <div className="column">
                            <Link to={`/overstock/${product.model}/edit`}>
                                <button type="button" className="button is-info is-pulled-right">
                                    <span className="icon">
                                        <i className="fas fa-pen"></i>
                                    </span>
                                    <span>Go to edit the model</span>
                                </button>
                            </Link>
                        </div>
                    </div>
                </>
            )
        }

        return (
            <>
                <div className="columns">
                    <div className="column is-2">

                        <div className="field">
                            <label className="label">Name</label>
                            <div className="control">
                                <input
                                    className="input"
                                    id="name"
                                    name="name"
                                    type="text"
                                    value={product.name}
                                    onChange={this.onChange}
                                    placeholder="Name" />
                            </div>
                        </div>

                        <div className="field">
                            <label className="label">Barcode</label>
                            <div className="control">
                                <input
                                    className="input"
                                    name="barcode"
                                    id="barcode"
                                    type="text"
                                    value={product.barcode}
                                    onChange={this.onChange}
                                    placeholder="XXXXXXXX"
                                    disabled={!["admin", "buyer"].includes(role)} />
                            </div>
                        </div>
                        <div className="field">
                            <label className="label">Id</label>
                            <div className="control">
                                <input
                                    className="input"
                                    name="id"
                                    id="id"
                                    type="text"
                                    value={product.uid}
                                    disabled={true}
                                    />
                            </div>
                        </div>

                        <div className="field">
                            <label className="label">Description</label>
                            <div className="control">
                                <input
                                    className="input"
                                    name="description"
                                    id="description"
                                    type="text"
                                    value={product.description}
                                    onChange={this.onChange}
                                    placeholder="Description"
                                     />
                            </div>
                        </div>
                        <TypeofgarmentSelect name="typeofgarment" label="Type Of Garment" value={product.typeofgarment} onChange={this.onChange}/>
                        <MintConditionSelect name="mintcondition" label="Condition" value={product.mintcondition} onChange={this.onChange}/>
                        <SizeSelect name="size" label="Size" value={product.size} onChange={this.onChange} />
                        
                       
                       
                        <GenderSelect name="gender" label="Gender" value={product.gender} onChange={this.onChange}/>
                        {/* <Web name="gender" label="Gender" value={product.gender} onChange={this.onChange}/> */}

                        {
                        window.localStorage.getItem('role') === 'admin'&&<PlatformSoldSelect  name="platformsold" value={product.platformsold} id="platformsold-select" label="Platform Sold" onChange={this.onChange} />
                        }
                        <MaterialComposition className="" editscreenProp="edit" setState={this.setState} state={product}  />
                        {/* <DatePickerYear name="yearofproduction" label="Year Of Production" value={product.yearofproduction} onChange={this.onChange}/> */}

                        <div className="field">
                            <label className="label">Year Of Production</label>
                            <div className="control">
                                <input
                                    className="input"
                                    name="yearofproduction"
                                    id="yearofproduction"
                                    type="text"
                                    value={product.yearofproduction}
                                    onChange={this.onChange}
                                    placeholder="Year Of Production"
                                     />
                            </div>
                        </div>
                        <div style={{display:'flex',alignItems:'center'}}>
                                        <Checkbox  name="sold" onChange={this.onChangeCheckbox} checked={product.sold}>
                                        </Checkbox>
                                        <label className="label">Sold</label>
                                    </div>
                        
                        <SupplierSelect name="supplier" label="Supplier" value={product.supplier} onChange={this.onChange} />

                        <BrandSelect name="brand" label="Brand" value={product.brand} onChange={this.onChange} />

                        <ColorSelect id="color-select" name="color" value={product.color} label="Colors" onChange={this.onChange} />


                        <CategoriesSelect name="category" value={product.category} label="Categories" onChange={this.onChange} />

                        <div className="field">
                            <label className="label">Location</label>
                            <div className="control">
                                <input
                                    className="input"
                                    name="location"
                                    id="location"
                                    type="text"
                                    value={product.location}
                                    disabled />
                            </div>
                        </div>
                    </div>

                    <div className="column">

                        <div className="columns">
                            <div className="column">
                                <ColorSelect id="color-select" name="color" value={product.color} label="Colors" onChange={this.onChange} />
                                <TagsSelect name="tags" label="Tags" value={product.tags} onChange={this.onChange} />
                                <ItemFamilySelect name="item_family" value={product.item_family} onChange={this.onChange} />
                                <WashingSelect name="washing" value={product.washing} label="Washing" onChange={this.onChange} />
                                <SizeSelect name="size" label="Size" value={product.size} onChange={this.onChange} />
                                <WashingDetergentButton name="washingdetergent" id="washingdetergent-select" value={product.washingdetergent} placeholder="Wash With" label="Wash With" onChange={this.onChange} />
                            
                                {
                               window.localStorage.getItem('role') === 'admin' || window.localStorage.getItem('role') === 'merchandiser'
                                || window.localStorage.getItem('role') === 'buyer' ?
                                <>
                                                                    
                        <div style={{ display: 'flex' }}>
                            <div className="field" style={{ width: "80%" }}>
                               <label className="label">Buying Price</label>
                               <div className="control">
                                   <input
                                       className="input"
                                       name="buyingprice"
                                       id="buyingprice"
                                       type="number"
                                       value={product.buyingprice}
                                       onChange={this.onChange}
                                       placeholder="Buying Price"
                                        />
                               </div>
                                    </div>
                                <div style={{width:'20%'}}>
                                    <CurrencySelect className="field" name="currency" value={product.currency} id="currency-select" label="Currency" onChange={this.onChange} />
                                </div>        
                                        
                            </div>
                        <div style={{ display: 'flex' }}>

                           <div className="field" style={{ width: "80%" }}>
                               <label className="label">Target Sale Price</label>
                               <div className="control">
                                   <input
                                       className="input"
                                       name="targetsalesprice"
                                       id="targetsalesprice"
                                       type="number"
                                       value={product.targetsalesprice}
                                       onChange={this.onChange}
                                       placeholder="Target Sales Price"
                                        />
                               </div>
                           </div>
                                <div style={{width:'20%'}}>
                                    <CurrencySelect className="field" name="currency" value={product.currency} id="currency-select" label="Currency" onChange={this.onChange} />
                                </div>
                                    </div>  
                        <div style={{ display: 'flex' }}>         
                           <div className="field" style={{ width: "80%" }}>
                               <label className="label">Final Sale Price</label>
                               <div className="control">
                                   <input
                                       className="input"
                                       name="finalsalesprice"
                                       id="finalsalesprice"
                                       type="number"
                                       value={product.finalsalesprice}
                                       onChange={this.onChange}
                                       placeholder="Final Sales Price"
                                        />
                               </div>
                                        </div>
                                <div style={{width:'20%'}}>
                                    <CurrencySelect className="field" name="currency" value={product.currency} id="currency-select" label="Currency" onChange={this.onChange} />
                                </div>
                        </div>
                           {
                                        product.finalsalesprice && product.buyingprice ?
                                        <div style={{ display: 'flex' }}>
                               <div className="field" style={{ width: "80%" }}>
                               <label className="label">Profit</label>
                               <div className="control">
                                   <input
                                       className="input"
                                       id="Profit"
                                       type="number"
                                       value={product.finalsalesprice - product.buyingprice} 
                                       placeholder="Profit"
                                        />
                               </div>
                                                </div>
                                                <div style={{width:'20%'}}>
                                    <CurrencySelect className="field" name="currency" value={product.currency} id="currency-select" label="Currency" onChange={this.onChange} />
                                </div>
                                                </div>
                                                :""
   
                           }</>:"" 
                        }
                            </div>

                            <div className="column">
                                <AttributeSelect name="attributes" label="Attributes" value={product.attributes} onChange={this.onChange} />
                                <CutSelect category={product.category} name="cuts" label="Cuts" value={product.cuts} onChange={this.onChange} />
                                <DetailsSelect name="details" id="details-select" value={product.details} placeholder="Details" label="Details" onChange={this.onChange} />
                                <div className="field">
                                    <CustomerSearchInput
                                        id="exluded-customer"
                                        placeholder="Type customer's name"
                                        name="excluded_customer"
                                        label="Exclude Customer"
                                        value={product.excluded_customer} onChange={this.onChange} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="columns">
                    <div className="column">
                        <button type="button" className="button is-primary is-pulled-right" onClick={this.saveChanges}>Save Changes</button>
                    </div>
                </div>
            </>
        );

    }

    renderLogs(product) {
        return (
            <ProductLogsContainer product={product} onLogsRetrieved={this.onLogsRetrieved} />
        )
    }

    renderRepairs(product) {
        return (
            <Reports barcode={product.barcode} />
        )
    }

    handleModal(num) {
        const { isModalVisible } = this.state;
        this.setState({ startIndex: num });

        this.setState({ isModalVisible: !isModalVisible });
    }

    handleArchiveModal() {
        const { isArchiveModalVisible } = this.state;
        this.setState({ isArchiveModalVisible: !isArchiveModalVisible });
    }

    render() {
        const { product, activeTab, isArchiveModalVisible } = this.state;
        if (!product.barcode) {
            return <div></div>;
        }

        let view = this.renderLogs(product);
        if (activeTab === 'Info') {
            view = this.renderInfo(product);
        }
        if (activeTab === 'Repairs') {
            view = this.renderRepairs(product);
        }
       
        let images = []
            if (product.beforewashImagesURL.frontUrl) {
                images.push({url:product.beforewashImagesURL.frontUrl})
        }
        if (product.beforewashImagesURL.backUrl) {
                images.push({url:product.beforewashImagesURL.backUrl})
        }
        if (product.afterwashImagesURL.frontUrl) {
                images.push({url:product.afterwashImagesURL.frontUrl})
        }
        if (product.afterwashImagesURL.backUrl) {
                images.push({url:product.afterwashImagesURL.backUrl})
        }
        
       
        return (
            <div className="columns is-gapless">

                <div className="column">
                    <div className="container">
                        <Link to={`/products`}>
                            <button className="button mt-4">
                                <span className="icon">
                                    <i className="fas fa-chevron-circle-left"></i>
                                </span>
                                <span>Go Back</span>
                            </button>
                        </Link>
                        <br />
                        <br />

                        <nav className="level">
                            <div className="level-left is-flex-direction-row is-align-items-flex-center" >
                                <div className="level-item has-text-centered" >

                                    <div>
                                    <ImageCom images={images.length-1} angle="Front" imageIndex={0} state={this.state} setState = {this.setState} onChange={this.onChangeImagesBF} handleModal={this.handleModal} src={product.beforewashImagesURL.frontUrl } />
                                    <br />

                                        <ImageCom images={images.length - 1} angle="Front" imageIndex={2} state={this.state} setState={this.setState} onChange={this.onChangeImagesAF} handleModal={this.handleModal} src={product.afterwashImagesURL.frontUrl} />
                                    </div>
                                    <div>
                                        
                                    <ImageCom images={images.length-1} imageIndex={1} state={this.state} setState = {this.setState} onChange={this.onChangeImagesBB} handleModal={this.handleModal} angle="Back" src={product.beforewashImagesURL.backUrl }/>
                                    <br />
                                        <ImageCom images={images.length - 1} imageIndex={3} setState={this.setState} handleModal={this.handleModal} onChange={this.onChangeImagesAB} angle="Back" src={product.afterwashImagesURL.backUrl} />
                                    </div>
                                    {/* <div>
                                        
                                        <ImagesUpload size="is-small" angle="Front" value={product.beforewashImagesURL.frontUrl} onChange={this.onChangeImagesBF} disabled={product.model} />
                                        <ImagesUpload size="is-small" angle="Front" value={product.afterwashImagesURL.frontUrl} onChange={this.onChangeImagesAF} disabled={product.model} />
                                    </div>
                                    <div>
                                        <ImagesUpload size="is-small"  angle="Back" value={product.beforewashImagesURL.backUrl} onChange={this.onChangeImagesBB} disabled={product.model} />
                                        <ImagesUpload size="is-small" angle="Back" value={product.afterwashImagesURL.backUrl} onChange={this.onChangeImagesAB} disabled={product.model} />
                                    </div> */}
                                </div>
                                
                                {/* <div className="level-item pr-6">
                                    <button className="button is-info" onClick={()=>this.handleModal()} disabled={ !product.beforewashImagesURL.frontUrl &&
                                        !product.beforewashImagesURL.backUrl &&
                                        !product.afterwashImagesURL.frontUrl &&
                                        !product.afterwashImagesURL.backUrl}>
                                        <span className="icon is-small">
                                            <i className="fas fa-search-plus"></i>
                                        </span>
                                    </button>
                                </div> */}
                                <div className="level-item has-text-centered">
                                    <div>
                                        <p><ItemStatusTag item={product} /></p>
                                        <h1 className="p-3 title">{product.name}</h1>
                                        <h2 className="p-3 subtitle">{product.barcode}</h2>
                                        {this.archiveButton()}
                                    </div>
                                </div>
                            </div>
                            <div className="level-right">
                                <div className="tabs is-large">
                                    <ul>
                                        {(DEFAULT_TABS.map((tab) => (
                                            <li key={tab} className={tab === activeTab ? 'is-active' : ''}>
                                                <a onClick={() => this.setActiveTab(tab)}>{tab}</a>
                                            </li>
                                        )))}
                                    </ul>
                                </div>
                            </div>
                        </nav>
                    </div>

                    <hr />

                    <div className="container">
                        {view}
                    </div>
                    {/* Modal */}
                    <div className={`modal ${this.state.isModalVisible ? 'is-active' : ''}`}>
                                {/* <img src={product.afterwashImagesURL["frontUrl"]} alt="" /> */}
                        <ImageModal
                            images={images}
                            handleModal={this.handleModal}
                            startIndex={this.state.startIndex}
                            />
                            
                        <button className="modal-close is-large" aria-label="close" onClick={this.handleModal}></button>
                    </div>
                    {/* Archiving Modal */}
                    <ModalArchive modal={isArchiveModalVisible} handleModal={this.handleArchiveModal} barcode={product.barcode} ></ModalArchive>
                </div >
            </div >
        );
    }
}

ProductEditContainer.contextType = AppContext;

ProductEditContainer.propTypes = {
    history: PropTypes.object
};

export default ProductEditContainer;
